export enum QuoteToolPreselectedModes {
  default = 'default',
  optOut = 'opt-out',
  studyAndStay = 'study-and-stay',
  onlineCourse = 'online-course',
  selectedSchool = 'selected-school',
  academicYearAbroad = 'academic-year-abroad',
  juniorCamp = 'junior-camp',
  payment = 'payment',
  adult = 'adult',
  junior = 'junior',
  aya = 'aya',
  online = 'online',
}
